import Icon from 'ui/Icon';
import Tooltip from 'ui/Tooltip';
import { Text } from 'ui/Typography';

const ViewOnlyInfo: React.FC = () => (
  <Tooltip content="This diagram is not yours and you don't have permissions to edit it.">
    <Text
      color="gray.600"
      cursor="help"
      fontSize="xs"
      fontWeight="medium"
      whiteSpace="nowrap"
    >
      <Icon icon="eye" px={1.5} />
      View-only
    </Text>
  </Tooltip>
);

export default ViewOnlyInfo;
